import { Objects } from "./objects";
import { SystemField } from "./system-field";

export class ObjectPermission extends SystemField{
    object_id?:string; 
    view?:string; 
    create?:string; 
    delete?:string; 
    edit?:string; 
    permission_id?:string;
    view_all?:string;

    //relationship
    object?:Objects;
    permission?:any;
}
